<script setup>
import { useStore } from "vuex";

const store = useStore();
</script>

<template>
  <v-footer app
            color="white"
            class="application-footer footer-layout"
  >
    <div v-if="store.getters.userAgent === 'mobile'" class="footer-mobile">
      <v-img alt="Qweb"
        src="https://ekaitakdkey.exactdn.com/wp-content/uploads/QuebecWood_final_rgb_FR-web.jpg?strip=all&lossy=1&ssl=1"
        :width="98" :height="90" />
      <v-img alt="Montreal wood convention"
        src="https://ekaitakdkey.exactdn.com/wp-content/uploads/MWC_Logo_Bilingue-WEB.jpg?strip=all&lossy=1&ssl=1"
        :width="168" :height="52" />
      <v-img alt="Canada Quebec Logo"
        src="https://ekaitakdkey.exactdn.com/wp-content/uploads/canada-quebec-1.png?strip=all&lossy=1&ssl=1"
        :width="195" :height="22" />
    </div>
    <div v-else class="footer-desktop">
      <div class="u-flex u-align-center">
        <v-img alt="Qweb"
          src="https://ekaitakdkey.exactdn.com/wp-content/uploads/QuebecWood_final_rgb_FR-web.jpg?strip=all&lossy=1&ssl=1"
          :width="98" :height="90" />
        <v-img alt="Montreal wood convention"
          src="https://ekaitakdkey.exactdn.com/wp-content/uploads/MWC_Logo_Bilingue-WEB.jpg?strip=all&lossy=1&ssl=1"
          class="app-bar-logo-large" />
      </div>
      <v-spacer></v-spacer>
      <div>
        <v-img alt="Canada Quebec Logo"
          src="https://ekaitakdkey.exactdn.com/wp-content/uploads/canada-quebec-1.png?strip=all&lossy=1&ssl=1"
          :width="195" :height="22" />
      </div>
    </div>
  </v-footer>
</template>

<style scoped>
@import '@/assets/styles/components/AppFooter.css';
</style>